import * as React from "react";
import { ChangeEvent } from "react";

import FieldError from "components/FormElements/FieldError";

interface PropsType {
  checked?: boolean;
  error?: string;
  id: string;
  label: JSX.Element | string;
  name?: string;
  onBlur?: () => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  value?: string;
}

export default function CheckboxField(props: PropsType): JSX.Element {
  const { error, id, label, ...inputProps } = props;

  return (
    <div className="form--checkbox-field wrapper_checkbox">
      <input type="checkbox" {...inputProps} {...{ id }} />
      <label id="label_checkbox_confirm_bank_account" htmlFor={id}>
        <span>{label}</span>
      </label>

      <FieldError {...{ error }} />
    </div>
  );
}
